// ============================================================================
// SWAHILI TRANSLATIONS - BIBLE TREASURES (HAZINA)
// ============================================================================
// Hazina za kiroho na lulu za hekima ya Biblia

export const bibleTreasures = [
  {
    type: "lulu_ya_hekima",
    content: "Yeye atembeaye na wenye hekima atakuwa na hekima, bali rafiki wa wapumbavu ataumia",
    reference: "Mithali 13:20",
    category: "hekima",
    strongNumbers: {
      "wenye_hekima": "H2450", // חכם (chakam) = mwenye hekima, mjanja
      "atembeaye": "H1980" // הלך (halak) = kutembea, kuishi
    },
    reflection: "Umuhimu wa kuchagua wenzako na waelekezi vizuri"
  },
  {
    type: "hazina_ya_kimungu",
    content: "Bwana yu karibu na wale walio na moyo uliovunjika, na huwaokoa wale walio na roho iliyopondeka",
    reference: "Zaburi 34:18",
    category: "faraja",
    strongNumbers: {
      "karibu": "H7138", // קרוב (qarob) = karibu, jirani
      "moyo_uliovunjika": "H7665" // שבר (shabar) = kuvunja, kuharibu
    },
    reflection: "Mungu yu karibu sana na wale wanaoteseka"
  },
  {
    type: "ahadi_ya_kimungu",
    content: "Kwa maana mawazo yangu si mawazo yenu, wala njia zenu si njia zangu, asema Bwana",
    reference: "Isaya 55:8",
    category: "siri_ya_kimungu",
    strongNumbers: {
      "mawazo": "H4284", // מחשבה (machashebah) = wazo, mpango
      "njia": "H1870" // דרך (derek) = njia, barabara
    },
    reflection: "Hekima ya Mungu inazidi ufahamu wetu wa kibinadamu"
  },
  {
    type: "ushawishi",
    content: "Uwe hodari na shujaa! Usiogope wala usifadhaike, kwa maana Bwana Mungu wako yu pamoja nawe",
    reference: "Yoshua 1:9",
    category: "ujasiri",
    strongNumbers: {
      "hodari": "H2388", // חזק (chazaq) = kuwa imara, kushikilia
      "shujaa": "H553" // אמץ (amats) = kuwa jasiri
    },
    reflection: "Ujasiri unatoka katika uwepo wa Mungu daima"
  },
  {
    type: "siri_ya_imani",
    content: "Basi imani ni uthibitisho wa mambo tunayotumaini, ushahidi wa mambo yasiyoonekana",
    reference: "Waebrania 11:1",
    category: "imani",
    strongNumbers: {
      "imani": "G4102", // πίστις (pistis) = imani, tumaini
      "uthibitisho": "G5287" // ὑπόστασις (hypostasis) = dutu, uthibitisho
    },
    reflection: "Imani inazidi kile kinachoonekana na hufanya halisi kile kisichoonekana"
  },
  {
    type: "ufunuo",
    content: "Lakini yeye atakayekunywa maji nitakayompa hatakuwa na kiu milele",
    reference: "Yohana 4:14",
    category: "maisha_ya_kiroho",
    strongNumbers: {
      "maji": "G5204", // ὕδωρ (hydor) = maji
      "kiu": "G1372" // διψάω (dipsao) = kuwa na kiu
    },
    reflection: "Yesu anatoa utoshelevu wa kiroho wa milele"
  },
  {
    type: "urithi_wa_kimungu",
    content: "Basi ikiwa sisi ni watoto, sisi pia ni warithi: warithi wa Mungu, na warithi pamoja na Kristo",
    reference: "Warumi 8:17",
    category: "utambulisho",
    strongNumbers: {
      "warithi": "G2818", // κληρονόμος (kleronomos) = mrithi
      "watoto": "G5043" // τέκνον (teknon) = mtoto, mzao
    },
    reflection: "Utambulisho wetu wa kimungu kama watoto na warithi wa Mungu"
  }
];

export default bibleTreasures;
